import { render, staticRenderFns } from "./agentChat.vue?vue&type=template&id=22473bb0&scoped=true"
import script from "./agentChat.vue?vue&type=script&lang=js"
export * from "./agentChat.vue?vue&type=script&lang=js"
import style0 from "./agentChat.vue?vue&type=style&index=0&id=22473bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22473bb0",
  null
  
)

export default component.exports